export default [{
    title: 'Evaluaciones',
    icon: 'BookmarkIcon',
    children: [
		 {
            title: 'Áreas Responsables',
            route: 'responsible-areas',
            action: 'read',
		    resource: 'responsible-areas'
        },
        {
            title: 'Criticidades',
            route: 'criticalities-list',
            action: 'read',
		    resource: 'criticalities'
        }, 
        {
            title: 'Desempeños',
            route: 'performances-list',
            action: 'read',
		    resource: 'perfomances'
        }, 
    ]
}];